module.exports = __webpack_public_path__ + "static/mr-press-27-d6f1ca24db5d9de9593b246cdd307d05.jpg";